import PreferenceKeys from "general/constants/PreferenceKeys";
import { t } from "i18next";
import { PERMISSIONS } from "pages/AuthorityRole/defineroles";
import { getRole } from "services/auth/permission";
import Swal from "sweetalert2";

async function getPermission() {
    let res = await getRole(localStorage.getItem(PreferenceKeys.savedLoginAccount));
    if (res.data.data.featureCodes == "*") {
        return PERMISSIONS.featureCodes;
    } else {
        let obj = {};

        res.data.data.featureCodes.split(";").map((item, index) => {
            if (!item.includes(':')) {
                // obj[item] = null;
            }
            else {
                let values = item.split(':')[1].split(',');
                if (values.length == 1 && values[0] == "") {
                    obj[item.split(':')[0]] = [];
                } else
                    obj[item.split(':')[0]] = item.split(':')[1].split(',');
            }
        });

        return obj;
    }
}

export default async function checkPermissionFunction(path, func, callback) {
    const featureCodes = await getPermission();
    if (featureCodes[path]?.includes(func)) {
        if (callback != null)
            await callback();
        return true;
    } else {
        if (callback != null) {
            Swal.fire({
                title: t('Confirm'),
                text: t('DeniedPermission'),
                icon: 'warning',
                confirmButtonText: t('Yes'),
                customClass: {
                    confirmButton: 'btn btn-danger font-weight-bolder',
                    cancelButton: 'btn btn-light font-weight-bolder',
                },
            }).then(async function (result) {
                if (result.value) {

                }
            });
        }
        return false;
    }
}

export async function checkPermission(path) {
    let res = await getRole(localStorage.getItem(PreferenceKeys.savedLoginAccount));
    let screens = res.data.data;
    if (screens.screenCodes == "*") {
        return true;
    }
    else {
        let splitFeatureCodes = await screens.screenCodes.split(';');

        let Codes = [];
        Codes = splitFeatureCodes.filter((item) => {
            return item.includes(path);
        });

        return Codes.length > 0 ? true : false;
    }
}